import * as xlsx from 'xlsx';


const numToAlpha = {
    "0":"A1",
    "1":"B1",
    "2":"C1",
    "3":"D1",
    "4":"E1",
    "5":"F1",
    "6":"G1",
    "7":"H1",
    "8":"I1",
    "9":"J1",
    "10":"K1",
    "11":"L1",
    "12":"M1",
    "13":"N1",
    "14":"O1",
    "15":"P1",
    "16":"Q1",
    "17":"R1",
    "18":"S1",
    "19":"T1",
    
}


export default function exportTableToExcel(data ,filename = "",column) {
  // var downloadLink;
  // var dataType = 'application/vnd.ms-excel';
  // var tableSelect = document.getElementById(tableID);
  // var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

  // // Specify file name
  // filename = filename?filename+'.xls':'excel_data.xls';

  // // Create download link element
  // downloadLink = document.createElement("a");

  // document.body.appendChild(downloadLink);

  // if(navigator.msSaveOrOpenBlob){
  //     var blob = new Blob(['\ufeff', tableHTML], {
  //         type: dataType
  //     });

  //     navigator.msSaveOrOpenBlob( blob, filename);

  // }else{
  //     // Create a link to the file
  //     downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

  //     // Setting the file name
  //     downloadLink.download = filename;

  //     //triggering the function
  //     downloadLink.click();
  // }

 console.log("runing")
  
  
  const workbook = xlsx.utils.book_new();

  const worksheet = xlsx.utils.json_to_sheet(data);

  for(let i =0; i<column.length;i++){
    worksheet[numToAlpha[i.toString()]].v=column[i]
  }

  xlsx.utils.book_append_sheet(workbook, worksheet, "sheet1");

  xlsx.writeFile(workbook,filename+".xlsx");

  
//   // Create a link to the file
//   downloadLink.href = "data:" + workbook;

//   // Setting the file name
//   downloadLink.download = filename+".xlsx";

//   //triggering the function
//   downloadLink.click();

  console.log(worksheet);
}
